import styled from '@emotion/styled';

export const StyledAlert = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	border: 1px solid var(--border-color);
	border-radius: 4px;
	gap: 0.5rem;
	padding: var(--padding-1);
	cursor: pointer;
	height: 100%;
`;
